import dynamic from 'next/dynamic';
import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import { Dropdown, DropdownItem } from 'shopper/components/Dropdown';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import { toLastCommentsLink } from 'lib/links';

import CommentsButton from './CommentsButton';

import LINKS from 'constants/links';
import TOPBAR from 'constants/topbar';

const Tag = dynamic(() => import('shopper/components/Tag'), {
  ssr: false,
});

const onOffersButtonClick = (_, gaEventCategory) =>
  sendEvent({ action: 'topbar_offers', category: gaEventCategory });

const TopbarBottomNav = ({
  commentsCount,
  gaEventCategory,
  onLastCommentsClick,
}) => {
  const [isOpen, setOpen] = useState(false);
  const dropdownButtonRef = useRef(null);

  const onDropdownButtonClick = () => {
    setOpen((prev) => !prev);
  };

  const onLastCommentsClickHandler = () => {
    sendEvent({ action: 'last_comments', category: gaEventCategory });
  };

  return (
    <>
      <NextLink href={LINKS.HIGH_OFFERS} prefetch={false} passHref>
        <Button
          as="a"
          type="ghost"
          size="size2"
          data-test-selector="high-offers-tab"
          iconRight={<Icon name="thermostat" />}
          mr={2}
        >
          <Text>{TOPBAR.BUTTON_HIGH_OFFERS}</Text>
        </Button>
      </NextLink>
      <NextLink href={LINKS.LOWEST_PRICE} prefetch={false} passHref>
        <Button
          as="a"
          type="ghost"
          size="size2"
          data-test-selector="lowest-price-offers-tab"
          iconRight={<Icon name="trending-down" />}
          mr={2}
          onClick={(e) => onOffersButtonClick(e, gaEventCategory)}
        >
          <Text>{TOPBAR.BUTTON_LOWEST_PRICE}</Text>
        </Button>
      </NextLink>
      <CommentsButton
        commentsCount={commentsCount}
        display={['none', null, null, null, 'block']}
        onClick={onLastCommentsClick}
      />
      <Block
        position="relative"
        height="fit-content"
        display={['none', null, null, 'block', 'none']}
      >
        <Button
          type="ghost"
          size="size2"
          aria-label="Mostrar naveção oculta"
          icon={<Icon name="more-alt" />}
          ref={dropdownButtonRef}
          onClick={onDropdownButtonClick}
        />
        <Dropdown
          align="right"
          id="topbar-bottom-items-nav"
          openerRef={dropdownButtonRef}
          open={isOpen}
          onClickOutside={() => setOpen(false)}
          renderToHTML
        >
          <NextLink href={toLastCommentsLink()} prefetch={false} passHref>
            <DropdownItem onClick={onLastCommentsClickHandler}>
              <Text>{TOPBAR.BUTTON_COMMENTS}</Text>
              {commentsCount > 0 && (
                <Tag size="size4" ml={2}>
                  {commentsCount}
                </Tag>
              )}
            </DropdownItem>
          </NextLink>
        </Dropdown>
      </Block>
    </>
  );
};

TopbarBottomNav.defaultProps = {
  commentsCount: 0,
  onLastCommentsClick: () => {},
};

TopbarBottomNav.propTypes = {
  commentsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  onLastCommentsClick: PropTypes.func,
};

export default TopbarBottomNav;
